define('app-Recaptcha/settings',[],function () {
    return {
        container: "#recaptcha-container",
        recaptchaWarning: "#recaptcha-warning"
    };
});

